import React from 'react';
import PropTypes from 'prop-types';

import Label from '@hydra/common/components/Label';
import Translate from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';

export const Custom404 = ({ criterium }) => {
  const { data, url } = criterium;

  const foundOrMissing = data.detected ? 'error_404_found' : 'error_404_missing';
  const isValidStatusCode = data.statusCode === 404;
  const labelStyle = isValidStatusCode ? 'success' : 'error';

  const content = (
    <>
      <Translate component='p' content={foundOrMissing} />
      <Translate content='custom_404_status_code' />
      {' '}
      <Label inline style={labelStyle} noBackground>
        {data.statusCode}
      </Label>
    </>
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

Custom404.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      detected: PropTypes.bool,
      statusCode: PropTypes.number
    })
  })
};

export default React.memo(Custom404);
